import abstractModel from '../../core/MercatelyModel';

const csrfToken = document.querySelector('[name=csrf-token]').content;
const resource = '/api/mia/chatbot/retailer_api_requests/test';

const model = abstractModel(resource);

// Always POST: payload.id is the auth method id, not a REST resource id.
model.test = (payload) => model.post(payload, { path: resource, csrfToken });

export default model;
